import React, {Component} from "react"
import PropTypes from "prop-types"
import styled from "styled-components"

import Card from "@irati/ui/src/Layout/Card"
import {Label2, Caption} from "@irati/ui/src/Labels"
import {Dosis} from "@irati/ui/src/global/fonts"
import {connect} from "@irati/store"
import media, {minWidthMedia} from "@irati/ui/src/global/media"
import {greys} from "@irati/ui/src/global/colors"
import padding from "@irati/ui/src/global/padding"
import {ButtonRouterLink} from "@irati/ui/src/Link"
import categoriesService from "@irati/deals/services/dealCategory"
import {walletTracking} from "@irati-tracking/wallet"
import {SPEND} from "@irati/deals/constants/categoryTypes"
import {FormattedMessage, FormattedCurrency, injectIntl} from "@irati/utils/lang"
import id from "@irati/utils/id"
import {IconTooltip} from "@irati/ui/src/Tooltip"

const StyledTooltip = styled(IconTooltip)`
  padding: 0 0 3px 5px;
  text-transform: lowercase;
`

const Content = styled.div`
  ${minWidthMedia.desktop`
    display: flex;
    align-items: center;
    padding-right: 15px;
  `}
`

const Info = styled.div`
  ${minWidthMedia.desktop`
    position: relative;
    width: 42%;
  `}
`

const Balances = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  ${media.desktop`
    padding-bottom: 10px;
  `}

  ${minWidthMedia.phoneLandscape`
    flex-direction: row;
    align-items: stretch;
  `}

  ${minWidthMedia.desktop`
    flex-direction: column;
    align-items: center;
    position: relative;
    width: 58%;
    padding-right: 50px;
  `}
`

const Balance = styled.div`
  ${Dosis}
  font-size: 45px;
  line-height: 50px;
  color: #1FAEEB;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;

  ${({pending}) => pending && `
    font-size: 30px;
    line-height: 35px;
    color: ${greys.medium};
    margin-top: 20px;
  `}

  ${minWidthMedia.phoneLandscape`
    ${({pending}) => pending && `
      margin: 0 0 0 50px;
    `}
  `}

  ${minWidthMedia.desktop`
    ${({pending}) => pending && `
      margin: 20px 0 0 0;
    `}
  `}

  ${Label2}{
    color: ${greys.black};
    margin-bottom: 10px;

    ${({pending}) => pending && `
      color: ${greys.mediumDark};
    `}
  }
`

const StyledCaption = styled(Caption)`
  color: ${greys.mediumDark};
  margin-bottom: ${padding.small};
  text-align: center;
`

const MarginButtonTop = styled(ButtonRouterLink)`
  margin-top: 15px;
`

class AvailableBalance extends Component {
  static propTypes = {
    wallet: PropTypes.shape({
      availableBalance: PropTypes.number.isRequired,
      scheduledInBalance: PropTypes.number.isRequired,
      currency: PropTypes.string.isRequired
    }).isRequired
  }

  static contextTypes = {
    apps: PropTypes.object.isRequired
  }

  constructor(props) {
    super(props)

    const loadCategories = categoriesService.listForCurrentPackage().then((dealCategories) => {
      this.setState({
        buttonLoad: null,
        spendCategory: dealCategories.find((category) => category.type === SPEND)
      })
    })

    this.state = {
      spendCategory: null,
      buttonLoad: loadCategories
    }
  }

  render() {
    const {wallet} = this.props
    const {availableBalance, scheduledInBalance, currency} = wallet
    const {spendCategory, buttonLoad} = this.state
    const {apps} = this.context

    const idNamespace = id("balances", this.props)

    return (
      <Card id={idNamespace}>
        <Content>
          <Balances>
            <Balance id={id("available-balance", idNamespace)}>
              <Label2 uppercase bold>
                <FormattedMessage id="wallet.availableBalance.available.header" />
              </Label2>
              {currency && <FormattedCurrency isCents={false} value={availableBalance} currency={currency} />}
            </Balance>
            <Balance pending id={id("pending-balance", idNamespace)}>
              <Label2 uppercase bold>
                <FormattedMessage id="wallet.availableBalance.pending.header" />
                <StyledTooltip placement="bottom">
                  <FormattedMessage id="wallet.availableBalance.pending.tooltip.text" />
                </StyledTooltip>
              </Label2>
              {currency && <FormattedCurrency isCents={false} value={scheduledInBalance} currency={currency} />}
            </Balance>
          </Balances>
          <Info>
            <StyledCaption><FormattedMessage id="wallet.availableBalance.info.text" /></StyledCaption>
            <ButtonRouterLink
              id={id("browse-perks-button", idNamespace)}
              primary
              full
              onClick={walletTracking.clickBrowsePerks}
              load={buttonLoad}
              to={spendCategory ? `/categories/${spendCategory.url}` : "/categories"}
              app={apps.PERKS}>
              <FormattedMessage id="wallet.availableBalance.info.button" />
            </ButtonRouterLink>
            <MarginButtonTop
              id={id("send-credit-button", idNamespace)}
              full
              load={buttonLoad}
              to="/send-credit">
              <FormattedMessage id="wallet.availableBalance.info.sendCreditbutton" />
            </MarginButtonTop>
          </Info>
        </Content>
      </Card>
    )
  }
}

const mapStateToProps = ({wallet}) => ({
  wallet
})

export default injectIntl(connect(mapStateToProps)(AvailableBalance))
